import React from 'react';

const StatCard = ({ label, value, icon, borderColor, onClick, active }) => (
  <button
    onClick={onClick}
    style={{
      backgroundColor: active ? 'var(--primary-light)' : 'var(--card-bg)',
      borderLeft: `3px solid ${borderColor}`,
      border: active ? `2px solid var(--primary)` : 'none',
      borderLeftWidth: '3px',
      borderLeftStyle: 'solid',
      borderLeftColor: borderColor,
      borderRadius: '4px',
      padding: '0.5rem 0.75rem',
      textAlign: 'center',
      minWidth: '100px',
      boxShadow: active ? '0 2px 8px rgba(13, 110, 253, 0.15)' : '0 1px 3px rgba(0,0,0,0.08)',
      cursor: 'pointer',
      transition: 'all 0.2s'
    }}
  >
    <div style={{ fontSize: '16px', fontWeight: '700', color: borderColor }}>{value}</div>
    <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{icon} {label}</div>
  </button>
);

const MessagesStatsBar = ({ stats, selectedFolder, setSelectedFolder }) => {
  if (!stats) return null;

  return (
    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem', flexWrap: 'wrap' }}>
      <StatCard
        label="Nieprzeczytane" value={stats.unread_count || 0} icon="IN"
        borderColor="var(--info)" onClick={() => setSelectedFolder('inbox')}
        active={selectedFolder === 'inbox'}
      />
      <StatCard
        label="Odebrane" value={stats.received_count || 0} icon="IN"
        borderColor="var(--success)" onClick={() => setSelectedFolder('inbox')}
        active={false}
      />
      <StatCard
        label="Wyslane" value={stats.sent_count || 0} icon="OUT"
        borderColor="var(--purple)" onClick={() => setSelectedFolder('sent')}
        active={selectedFolder === 'sent'}
      />
      <StatCard
        label="Pilne" value={stats.urgent_count || 0} icon="!"
        borderColor="var(--danger)" onClick={() => {}}
        active={false}
      />
    </div>
  );
};

export default MessagesStatsBar;
